import React from "react";

import Component from "components/component";

export default class SelectionPrompt extends Component {
  render() {
    return <p className="selection-prompt">Make a Selection</p>;
  }
}
